<div class="flex-row links" (click)="onAction()">
  <mat-icon>{{ icon }}</mat-icon>
  @if (!loading) {
  <span [matTooltip]="tooltip | translate">{{ label | translate }}</span>
  } @if (loading) {
  <span>{{ loadingLabel | translate }}</span>
  } @if (showInfoIcon) {
  <mat-icon class="info-icon" (click)="onInfoAction($event)">info</mat-icon>
  }
</div>
